import styled, { css } from 'styled-components';

export const HiddenInput = styled.input`
  display: none;
`;

export const Grid = styled.div<{ $gridColumnCount: number }>`
  display: grid;
  gap: var(--sizes-40) var(--sizes-60);
  ${({ $gridColumnCount }) => css`
    grid-template-columns: repeat(${$gridColumnCount}, 1fr);
  `};
`;

export const Container = styled.div<{ $fullWidth: boolean }>`
  grid-column: 2 / span 3;
  ${({ $fullWidth }) =>
    $fullWidth &&
    css`
      width: 100%;
    `}
`;
